import { type SearchCommentTimeline } from '@models/searchCommentTimeline.ts';
import { Requests } from '@tools/requests';
import {
  URL_XHR_CREATE_SEARCH_COMMENT_TIMELINE,
  URL_XHR_SEARCH_COMMENT_TIMELINES,
} from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { flashBagError } from '@tools/flashbag';

export const getSearchCommentTimelines = async ({
  searchCommentId,
}: {
    searchCommentId: number;
}): Promise<SearchCommentTimeline[]> => {
  try {
    const { data }: { data: SearchCommentTimeline[] } = await Requests.get(
      URL_XHR_SEARCH_COMMENT_TIMELINES.replace(
        '{searchCommentId}',
        searchCommentId.toString(),
      ),
    );

    return data;
  } catch (error) {
    Logger.error(error);
    flashBagError();
  }

  return [];
};

export const createSearchCommentTimeline = async (content: {
    searchCommentId: number | null;
    proposalId: number | null;
    selectionItemId: number;
    body: string;
}): Promise<SearchCommentTimeline | null> => {
  try {
    const { data }: { data: SearchCommentTimeline } = await Requests.post(
      URL_XHR_CREATE_SEARCH_COMMENT_TIMELINE,
      {
        searchCommentId: content.searchCommentId,
        proposalId: content.proposalId,
        selectionItemId: content.selectionItemId,
        body: content.body,
      },
    );

    return data;
  } catch (error) {
    Logger.error(error);
    flashBagError();
  }

  return null;
};
